import React from 'react'
import ModalComponent from '../component/ModalComponent'
import AddAppointment from './AddAppointment'

const NewAppoinment = (props:any) => {
  const {showAppointment,setShowAppointment,refetch} = props
  return (
    <div>
        <ModalComponent
        size="lg"
        title="Create New Appointment"
        show={showAppointment}
        body={<AddAppointment setShowAppointment={setShowAppointment} refetchappoinment={refetch}/>}
        onClose={() => setShowAppointment(false)}
      />
    </div>
  )
}

export default NewAppoinment